// @flow
export default {
  app: {
    railsEnv: 'staging'
  },
}
